import { render } from "./GroupOperationsPopover.vue?vue&type=template&id=10eff1b4&scoped=true"
import script from "./GroupOperationsPopover.vue?vue&type=script&lang=js"
export * from "./GroupOperationsPopover.vue?vue&type=script&lang=js"

import "./GroupOperationsPopover.vue?vue&type=style&index=0&id=10eff1b4&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10eff1b4"]])

export default __exports__